import { useQuery } from '@tanstack/react-query';
import { Patient } from '@/lib/types/patient';
import { fetchPatients } from '../api/patients';

interface UsePatientOptions {
  search?: string;
  dateRange?: [Date | null, Date | null];
  status?: 'all' | 'active' | 'inactive';
}

export function usePatients(options: UsePatientOptions = {}) {
  return useQuery<Patient[]>({
    queryKey: ['patients', options],
    queryFn: () => fetchPatients(options),
  });
}